/* eslint-disable react/prop-types */
import axios from 'axios';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
// api
import ApiKey from '../../../api/ApiKey';
import BaseApi from '../../../api/BaseApi';
// components
import SmallLoading from '../../SmallLoading';
// helpers
import { formatPhoneNumber, resultInfo } from '../../../helpers';
// hooks
import { useWindowSize } from '../../../../Hooks/use-window-size';
// mui
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { DateUtilsService } from 'shared/utils/date-utils.service'
const currencies = {
  '1': '₴',
  '2': '$',
  '3': '€',
};

const getFormatedMessengerLink = (type, link) => {
  let formattedLink;

  switch (type) {
    case 'WhatsApp':
      formattedLink = `https://wa.me/${link.replace(/\D/g, '')}`;
      break;
    case 'Signal':
      formattedLink = `https://signal.me/#p/${link.replace(/\D/g, '')}`;
      break;
    case 'Viber':
      formattedLink = `viber://chat?number=${link.replace(/\D/g, '')}`;
      break;
    case 'Telegram':
      formattedLink = `https://t.me/${link}`;
      break;
    case 'Skype':
      formattedLink = `skype:${link}?chat`;
      break;
    case 'Discord':
      formattedLink = `https://discord.com/users/${link}`;
      break;
    default:
      formattedLink = link;
  }

  return formattedLink;
};

const calculateAge = birthday => {
  const today = new Date();
  const birthDate = new Date(birthday);

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

const PersonalInfo = ({ cv_id, cvDetails, comment }) => {
  const { id } = useParams();
  const { width } = useWindowSize();
  const { pathname } = useLocation();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');
  const cvId = id || cv_id;

  const {
    city = '',
    gender = '',
    birthday = '',
    position = '',
    last_name = '',
    work_type = [],
    first_name = '',
    salary_max = '',
    salary_min = '',
    middle_name = '',
    relocations = [],
    social_links =[],
    email_address = '',
    profile_image = '',
    video_cv_link = '',
    contact_number = '',
    messenger_links = [],
    salary_currency = '',
    contact_number_2 = '',
    contact_number_3 = '',
    desired_category = [],
    is_open_contact = false,
    contact_available = false,
  } = cvDetails;

  const [contactsData, setContactsData] = useState(null);
  const [smallLoading, setSmallLoading] = useState(false);

  const getContactsData = async () => {
    try {
      setSmallLoading(true);

      const response = await axios.post(
        BaseApi + `/candidates/getContacts/${cvId}`,
        null,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      setSmallLoading(false);

      if (response.data.status === 200) {
        setContactsData(response.data.response);
      } else if (response.data.status === 422) {
        resultInfo('warning', response.data.response, t('jobseekerManageAlert.close'));
      } else {
        resultInfo('error', response.data.message, t('jobseekerManageAlert.close'));
      }
    } catch (error) {
      setSmallLoading(false);

      if (error.response.data.status === 422) {
        resultInfo('warning', error.response.data.message, t('jobseekerManageAlert.close'));
      } else if (error.response.status === 500) {
        resultInfo('error', error.message, t('jobseekerManageAlert.close'));
      }

      console.error('Could not get contacts data', error);
    }
  };

  useEffect(() => {
    if (is_open_contact) {
      getContactsData();
    }
  }, [is_open_contact]); // eslint-disable-line


  const renderLastActivityDate =()=> {
    if(!cvDetails.modified) {
      return null;
    }
    const date = DateUtilsService.toAppFormat(cvDetails.modified)
    if(cvDetails.update_source === 2) {
    return  (
                  <p>
                    <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#294A9C' }} />
                    {"Остання активність - "}  
                    {date}
                  </p>
                )
    } else {
      return (
                  <p>
                    <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#294A9C' }} />
                   {t('cvCard.updated') + ' - '}
                    {date}
                  </p>
                )
    }

  }
   
  return (
    <div className='personalInfoSection'>
      <div>
        <h1>
          {position?.label}
        </h1>
        <div className='personalInfoBox'>
          <div className='genderAgeRegionBox'>
            {
              gender !== null
                ? (
                  <p>
                    <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#294A9C' }} />
                    {gender == 1 ? t('cvCard.male') : t('cvCard.female')}
                  </p>
                )
                : ''
            }
            {
              birthday
                ? (
                  <p>
                    <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#294A9C' }} />
                    {t('cvCard.age')} - {calculateAge(birthday)}
                  </p>
                )
                : ''
            }
            {
              city
                ? (
                  <p>
                    <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#294A9C' }} />
                    {city && city.label}
                  </p>
                )
                : ''
            }
            {renderLastActivityDate()}
          </div>
          {
            contactsData !== null && userType === 'recruiter' && !pathname.startsWith('/admin') && !pathname.startsWith('/candidates/profile/') && (
              <h2>
                {contactsData?.last_name}{' '}{contactsData?.first_name}{' '}{contactsData?.middle_name && contactsData.middle_name}
              </h2>
            )
          }
          {
            (userType === 'candidate' || pathname.startsWith('/admin') || pathname.startsWith('/candidates/profile/')) && (
              <h2>
                {last_name}{' '}{first_name}{' '}{middle_name && middle_name}
              </h2>
            )
          }
          <h3>
            {
              salary_max || salary_min
                ? (
                  <>
                    {salary_min ? parseInt(salary_min).toLocaleString('uk-UA') : ''}
                    {salary_min && salary_max ? ' - ' : ''}
                    {salary_max ? parseInt(salary_max).toLocaleString('uk-UA') : ''}
                    {' '}
                    {salary_currency && currencies[salary_currency]}
                    {salary_currency && `/${t('cvCard.month')}`}
                  </>
                )
                : t('cvCard.salaryNotSpecified')
            }
          </h3>
          {
            contact_available
              && (
                contactsData === null && userType === 'recruiter' && !is_open_contact && !pathname.startsWith('/admin') && (
                  <button
                    className='mt-4 btn button1'
                    onClick={() => getContactsData()}
                    disabled={smallLoading}
                  >
                    {t('cvDescription.openContacts')}{' '}
                    {smallLoading && <SmallLoading color='#FFFFFF' width='20' height='20' />}
                  </button>
                )
              ) 
          }
        </div>
        {
          contactsData !== null && userType === 'recruiter' && !pathname.startsWith('/admin') && !pathname.startsWith('/candidates/profile/') && (
            <>
              <div className='contactsBox'>
                {
                  contactsData?.contact_number && (
                    <p>
                      <i className='fa-solid fa-phone' />
                      <a href={`tel:${contactsData?.contact_number}`}>
                        {formatPhoneNumber(contactsData?.contact_number)}
                      </a>
                    </p>
                  )
                }
                {
                  contactsData?.contact_number_2 && (
                    <p>
                      <i className='fa-solid fa-phone' />
                      <a href={`tel:${contactsData?.contact_number_2}`}>
                        {formatPhoneNumber(contactsData?.contact_number_2)}
                      </a>
                    </p>
                  )
                }
                {
                  contactsData?.contact_number_3 && (
                    <p>
                      <i className='fa-solid fa-phone' />
                      <a href={`tel:${contactsData?.contact_number_3}`}>
                        {formatPhoneNumber(contactsData?.contact_number_3)}
                      </a>
                    </p>
                  )
                }
                <p>
                  <i className='fa-solid fa-envelope' />
                  <a href={`mailto:${contactsData?.email_address}`}>
                    {contactsData?.email_address}
                  </a>
                </p>
                {
                  contactsData?.video_cv_link && (
                    <p>
                      <i className='fa-solid fa-video' />
                      <a href={contactsData?.video_cv_link} target='_blank' rel='noopener noreferrer nofollow'>
                        {t('cvDescription.videoCV')}
                      </a>
                    </p>
                  )
                }
              </div>
            
              {
                (
                  (contactsData?.messenger_links?.length > 0 && contactsData?.messenger_links[0]?.type) ||
                  (contactsData?.social_links?.length > 0 && contactsData?.social_links[0]?.type)
                ) && (
                  <div className='socialLinksBox'>
                    <div className='messengersLinks'>
                      {
                        contactsData?.messenger_links?.filter(ms=> !!ms.link).map(i => (
                          <a key={i.id} href={getFormatedMessengerLink(i.type, i.link)} target='_blank' rel='noopener noreferrer nofollow'>
                            <button className='btn' title={i.type}>
                              <i className={`fa-brands fa-${i.type === 'Signal' ? 'signal-messenger' : i.type?.toLowerCase()}`} />
                            </button>
                          </a>
                        ))
                      }
                    </div>
                    {width >= 768 && contactsData?.messenger_links[0]?.type && contactsData?.social_links[0]?.type && <div className='verticalStrip'></div>}
                    <div className='socialLinks'>
                      {
                        contactsData?.social_links?.map(i => (
                          <a key={i.id} href={i.link} target='_blank' rel='noopener noreferrer nofollow'>
                            <button className='btn' title={i.type}>
                              <i className={`fa-brands fa-${i.type === 'Twitter' ? 'x-twitter' : i.type?.toLowerCase()}`} />
                            </button>
                          </a>
                        ))
                      }
                    </div>
                  </div>
                )
              }
            </>
          )
        }
        {
          (userType === 'candidate' || pathname.startsWith('/admin') || pathname.startsWith('/candidates/profile/')) && (
            <>
              <div className='contactsBox'>
                {
                  contact_number && (
                    <p>
                      <i className='fa-solid fa-phone' />
                      <a href={`tel:${contact_number}`}>
                        {formatPhoneNumber(contact_number)}
                      </a>
                    </p>
                  )
                }
                {
                  contact_number_2 && (
                    <p>
                      <i className='fa-solid fa-phone' />
                      <a href={`tel:${contact_number_2}`}>
                        {formatPhoneNumber(contact_number_2)}
                      </a>
                    </p>
                  )
                }
                {
                  contact_number_3 && (
                    <p>
                      <i className='fa-solid fa-phone' />
                      <a href={`tel:${contact_number_3}`}>
                        {formatPhoneNumber(contact_number_3)}
                      </a>
                    </p>
                  )
                }
                <p>
                  <i className='fa-solid fa-envelope' />
                  <a href={`mailto:${email_address}`}>
                    {email_address}
                  </a>
                </p>
                {
                  video_cv_link && (
                    <p>
                      <i className='fa-solid fa-video' />
                      <a href={video_cv_link} target='_blank' rel='noopener noreferrer nofollow'>
                        {t('cvDescription.videoCV')}
                      </a>
                    </p>
                  )
                }
              </div>
              {
                ((messenger_links?.length > 0 && messenger_links[0]?.type) || (social_links?.length > 0 && social_links[0]?.type)) && (
                  <div className='socialLinksBox'>
                    <div className='messengersLinks'>
                      {
                        messenger_links?.map(i => (
                          <a key={i.id} href={getFormatedMessengerLink(i.type, i.link)} target='_blank' rel='noopener noreferrer nofollow'>
                            <button className='btn' title={i.type}>
                              <i className={`fa-brands fa-${i.type === 'Signal' ? 'signal-messenger' : i.type?.toLowerCase()}`} />
                            </button>
                          </a>
                        ))
                      }
                    </div>
                    {width >= 768 && messenger_links[0]?.type && social_links[0]?.type && <div className='verticalStrip'></div>}
                    <div className='socialLinks'>
                      {
                        social_links?.map(i => (
                          <a key={i.id} href={i.link} target='_blank' rel='noopener noreferrer nofollow'>
                            <button className='btn' title={i.type}>
                              <i className={`fa-brands fa-${i.type === 'Twitter' ? 'x-twitter' : i.type?.toLowerCase()}`} />
                            </button>
                          </a>
                        ))
                      }
                    </div>
                  </div>
                )
              }
            </>
          )
        }
        { userType === 'recruiter' && comment}
        <div className='wishesInfoBox'>
          <p>
            <i className='fa-solid fa-sitemap' />
            <span>{t('cvDescription.category')}{': '}</span>
            {
              desired_category?.length > 0
                ? (
                  Array.from(new Set(
                    desired_category?.map(i => i.category),
                  )).join('; ')
                )
                : t('cvCard.notSpecified')
            }
          </p>
          <p>
            <i className='fa-solid fa-sitemap' />
            <span>{t('cvDescription.subCategory')}{': '}</span>
            {
              desired_category?.length > 0
                ? (
                  Array.from(new Set(
                    desired_category?.flatMap(category =>
                      category.sub_category.map(subCategory => subCategory.label),
                    ),
                  )).join(', ')
                )
                : t('cvCard.notSpecified')
            }
          </p>
          <p>
            <i className='fa-sharp fa-solid fa-location-dot' />
            <span>{t('cvDescription.relocations')}{': '}</span>
            {
              relocations?.length > 0
                ? relocations?.map(i => i.label).join('; ')
                : t('cvCard.notSpecified')
            }
          </p>
          <p>
            <i className='fa-solid fa-clock' />
            <span>{t('cvDescription.workType')}{': '}</span>
            {
              work_type?.length > 0
                ? work_type?.map(i => i.label).join(', ')
                : t('cvCard.notSpecified')
            }
          </p>
        </div>
      </div>
      <div className='profileImageBox'>
        <img
          alt='profile image'
          className='profileImage'
          src={(profile_image && !profile_image.endsWith('/')) ? profile_image : '/Images/jobseekerSide/dummy-profile.png'}
        />
      </div>
    </div>
  );
};

export default PersonalInfo;
